<template>
  <div class="card-content">
    <div class="card-content-title">
      <span><Skeleton width="100px" height="10px" /></span>
      <span><Skeleton width="360px" height="16px" /></span>
    </div>

    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>
    </div>
    <div>
      <span class="mb-5"><Skeleton width="200px" height="10px" /></span>
      <strong><Skeleton width="200px" height="10px" /></strong>
    </div>
  </div>
</template>
<script>
import Skeleton from '@/components/Skeleton/Skeleton';

export default {
  name: 'InvoiceCardSkeleton',
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';

span {
  display: block;
}

strong {
  display: block;
}

.card-content-title{
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-content-item {
  width: calc(100% - 10px);
  height: 76px;
  padding: 12px;
  span {
    margin-bottom: 8px;
  }
}
</style>
